import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGrit} from "../../TrueGrit";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {gsap} from "gsap";
import {TrueGritGameMode} from "../../server/TrueGritGameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TrueGritGameAssets} from "../../TrueGritGameAssets";
import {TrueGritSound} from "../../sound/TrueGritSound";

/**
 * Created by Jerker Nord on 2021-09-25.
 */

export class TrueGritSuperFreeSpinIntroView extends PIXI.Container implements StageLayer {

    private _superFsIntroBGImage:PIXI.Sprite;
    private _superFsTextImage:PIXI.Sprite;
    private _superFsImageImage:PIXI.Sprite;
    private _button:ContinueButton;
    private _clickCallback:Function;
    private _fullScreen:PIXI.Graphics;
    private _spinsAndTextContainer:PIXI.Container;
    private _superFsWonText:PIXI.BitmapText;

    constructor() {
        super();
        this.name = "TrueGritSuperFreeSpinIntroView";
        this.init();
    }

    private init() {
        this.visible = false;
        const bounds:ScreenBounds = NolimitApplication.screenBounds;
        this._fullScreen = new PIXI.Graphics();
        this._fullScreen.clear();
        this._fullScreen.beginFill(0x000000, 0.7);
        this._fullScreen.drawRect(bounds.left, bounds.top, bounds.width, bounds.height);
        this._fullScreen.endFill();
        this.addChild(this._fullScreen);

        this._superFsIntroBGImage = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.FS_INTRO_BACKGROUND)[0]);
        this._superFsIntroBGImage.anchor.set(0.5, 0.5);
        this._superFsIntroBGImage.position.set(360, 360);
        this._superFsIntroBGImage.alpha = 0;
        this.addChild(this._superFsIntroBGImage);

        this._spinsAndTextContainer = new PIXI.Container();
        this._spinsAndTextContainer.position.y = 110;
        this.addChild(this._spinsAndTextContainer);

        this._superFsWonText = new PIXI.BitmapText("", {
            fontName : TrueGritGameAssets.BITMAP_FONT_FS_NUMBERS,
            fontSize : 104
        });
        this._superFsWonText.alpha = 0;
        this._spinsAndTextContainer.addChild(this._superFsWonText);

        this._superFsTextImage = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.DEAD_SPINS_LOGO)[0]);
        this._superFsTextImage.alpha = 0;
        this._spinsAndTextContainer.addChild(this._superFsTextImage);

        this._superFsImageImage = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.DEAD_SPINS_INTRO_BANNER)[0]);
        this._superFsImageImage.alpha = 0;
        this._superFsImageImage.anchor.set(0.5, 0);
        this._superFsImageImage.position.set(360, 224);
        this.addChild(this._superFsImageImage);

        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick());
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.enable(false)
        this._button.alpha = 0;
        this.addChild(this._button);

        if(TrueGrit.model.isRestore == true && (TrueGrit.model.data.mode == TrueGritGameMode.FREESPIN_SUPER || TrueGrit.model.data.mode == TrueGritGameMode.FREESPIN_SUPER_AVALANCHE)) {
            SlotGame.keypadPlugin.setZeroBetSpinCounter(Math.max(TrueGrit.model.freespinsLeft, 0));
        }

        this.onResize();
    }

    onResize():void {
        const bounds:ScreenBounds = NolimitApplication.screenBounds;
        this.position.y = 0;
        this._fullScreen.clear();
        this._fullScreen.beginFill(0x000000, 0.7);
        this._fullScreen.drawRect(bounds.left, bounds.top, bounds.width, bounds.height);
        this._fullScreen.endFill()

        //Copied from Launcher/GameIntroView, so we get consistent placement of buttons
        if(NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom-80);
        }

    }

    private onButtonClick() {
        const hideSuperFSIntroTL:gsap.core.Timeline = new gsap.core.Timeline();
        hideSuperFSIntroTL.add(() => this._button.enable(false));
        hideSuperFSIntroTL.add(() => {TrueGrit.soundPlayer.playSound(TrueGritSound.FS_SUPER_NORMAL_START)});
        hideSuperFSIntroTL.add(() => {TrueGrit.soundPlayer.stopSound(TrueGritSound.FS_INTRO_MUSIC_NAME)});
        hideSuperFSIntroTL.add(() => {
            if(TrueGrit.model.isRestore == true) {
                SlotGame.keypadPlugin.setZeroBetSpinCounter(Math.max(TrueGrit.model.data.freespinsLeft, 0));
            } else {
                SlotGame.keypadPlugin.setZeroBetSpinCounter(TrueGrit.model.freespinsLeft);
            }
        });
        hideSuperFSIntroTL.add([
            new gsap.core.Timeline({delay : 1.248}).add(() => TrueGrit.soundPlayer.switchMusic(TrueGrit.model.data.nextMode)),
            gsap.to(this._button, {duration : 0.4, alpha : 0}),
            gsap.to(this._superFsIntroBGImage, {duration : 0.6, alpha : 0}),
            gsap.to(this._superFsImageImage, {duration : 0.6, alpha : 0}),
            gsap.to(this._fullScreen, {duration : 0.6, alpha : 0}),
            gsap.to(this._superFsImageImage, {duration : 0.6, alpha : 0}),
            gsap.to(this._superFsWonText, {duration : 0.6, alpha : 0}),
            gsap.to(this._superFsTextImage, {duration : 0.6, alpha : 0}),
            SlotGame.keypadPlugin.show()
        ]);
        hideSuperFSIntroTL.add(() => {this.visible = false});
        hideSuperFSIntroTL.add(() => this._clickCallback());
    }

    public showSuperFSIntro(callback:Function):void {
        let startDelay:number = 1;
        if(TrueGrit.model.isRestore == true) {
            startDelay = 0.2;
        }
        const showSuperFSIntroTL:gsap.core.Timeline = new gsap.core.Timeline({delay : startDelay});

        showSuperFSIntroTL.add(() => {
            this._clickCallback = callback;
            this._fullScreen.alpha = 0;
            this._superFsWonText.text = TrueGrit.model.data.freespinsLeft.toString();
            this._superFsTextImage.position.x = this._superFsWonText.width + 8;
            this._spinsAndTextContainer.position.x = 360 - (this._spinsAndTextContainer.width / 2);
            this._superFsTextImage.position.y = (this._superFsWonText.position.y + (this._superFsWonText.height / 2)) - (this._superFsTextImage.height / 2)
            this.visible = true;
        });

        showSuperFSIntroTL.add([
            gsap.to(this._superFsImageImage, {duration : 0.4, alpha : 1}),
            gsap.to(this._fullScreen, {duration : 0.4, alpha : 1}),
            gsap.to(this._button, {duration : 0.4, alpha : 1}),
            gsap.to(this._superFsIntroBGImage, {duration : 0.8, alpha : 1}),
            gsap.to(this._superFsTextImage, {duration : 0.8, alpha : 1}),
            gsap.to(this._superFsWonText, {duration : 0.8, alpha : 1}),
            () => TrueGrit.backgroundElements.setMode(TrueGritGameMode.FREESPIN_SUPER, 2),
            () => TrueGrit.foregroundElements.setMode(TrueGritGameMode.FREESPIN_SUPER, 2),
            () => TrueGrit.reelBackgroundView.setMode(TrueGritGameMode.FREESPIN_SUPER, 2),
            () => TrueGrit.soundPlayer.playSound(TrueGritSound.FS_INTRO_START),
            new gsap.core.Timeline({delay : 0.279}).add(() => TrueGrit.soundPlayer.switchMusic(TrueGritSound.FS_INTRO_MUSIC_NAME))
        ]);
        showSuperFSIntroTL.add(() => this._button.enable(true));
    }
}